import { QuestionGroupType } from '@exam-management/graphql';
import { Button, EditOutlinedIcon } from '@shared/components';

import { QuestionChangeModalAction, useQuestionChangeModal } from '../../providers';

interface QuestionChangeButtonProps {
  questionType?: QuestionGroupType;
}

export default function QuestionChangeButton(props: Readonly<QuestionChangeButtonProps>) {
  const { questionType } = props;
  const { setAction } = useQuestionChangeModal();
  const handleClickQuestionChange = () => {
    if (questionType === QuestionGroupType.ItemSet) {
      setAction(QuestionChangeModalAction.ITEM_SET_QUESTION_CHANGE);
    } else if (
      questionType === QuestionGroupType.Single ||
      questionType === QuestionGroupType.LotOfQuestion
    ) {
      setAction(QuestionChangeModalAction.SINGLE_QUESTION_CHANGE);
    }
  };

  return (
    <Button
      variant='outlined'
      color='secondary'
      startIcon={<EditOutlinedIcon />}
      onClick={handleClickQuestionChange}
    >
      Change Question
    </Button>
  );
}
